import { makeAutoObservable } from 'mobx';
import { ShareContactViewModel } from '@pages/auth/Login/ui/ShareContact/types';
import { reformatPhone } from '@shared/utils/helpers/formatString';
import { PATH_AUTH } from '@app/routes/paths';
import { notifications } from '@shared/utils/notifications';
import { type NavigateFunction } from 'react-router-dom';

const apiUrl = import.meta.env.VITE_REACT_APP_API_URL ?? 'http://localhost:3000';
const wsUrl = `${apiUrl?.replace('http', 'ws')}/ws`;

export class ViewModel implements ShareContactViewModel {
  phone = '';

  navigate: NavigateFunction | null = null;

  private _socket: WebSocket | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  onShareSuccess = async () => {};

  startWaiting = async () => {
    this._socket = new WebSocket(wsUrl);
    if (!this._socket) return;

    this._socket.onmessage = (msg) => {
      if (msg.data === 'connection_timeout') {
        this.navigate?.(PATH_AUTH.checkContact);
        notifications.warning('Время ожидания истекло');
      }
      if (msg.data === 'success') {
        this.onShareSuccess();
      }
    };

    this._socket.onopen = () => {
      const rawPhone = reformatPhone(this.phone);
      this.sendMessage({
        name: 'wait_end_registration',
        data: {
          phone: rawPhone
        }
      });
    };

    this._socket.onerror = (err) => {
      console.error('Ошибка WebSocket:', err);
    };

    this._socket.onclose = (event) => {
      console.debug('WebSocket закрыт: ', event.code);
      this.cleanup();
    };
  };

  cleanup = async () => {
    this.sendMessage({
      name: 'stop_wait_end_registration'
    });
    this._socket?.close();
    this._socket = null;
  };

  private sendMessage = (message: any) => {
    if (!this._socket?.readyState) return;

    if (this._socket?.readyState === WebSocket.CLOSED) return;

    this._socket.send(JSON.stringify(message));
  };
}
